export default __webpack_public_path__ + "static/media/placeholder.557780a9.png";